import { render, staticRenderFns } from "./new-trails.vue?vue&type=template&id=418f4edc&scoped=true&"
import script from "./new-trails.vue?vue&type=script&lang=js&"
export * from "./new-trails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418f4edc",
  null
  
)

export default component.exports